export default "__VITE_ASSET__Cg4UkiX9__"